import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { Pedido } from '../../pedido/models/pedido';
import { PedidoService } from '../../pedido/pedido.service';




@Injectable({ providedIn: 'root'})
export class EventoPedidoDetalheResolver implements Resolve<Observable<Pedido>>{

    constructor(private pedidoService: PedidoService) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const idPedido = route.params.id;
        return this.pedidoService.getPedidoEvento(idPedido);
    }

}